export const FETCH_LIST_TRANSFER_PATIENT_REQUEST= "FETCH_LIST_TRANSFER_PATIENT_REQUEST";
export const FETCH_LIST_TRANSFER_PATIENT_SUCCESS= "FETCH_LIST_TRANSFER_PATIENT_SUCCESS";
export const FETCH_LIST_TRANSFER_PATIENT_FAILURE= "FETCH_LIST_TRANSFER_PATIENT_FAILURE";

// View single transfer patient
export const FETCH_TRANSFER_PATIENT_REQUEST= "FETCH_TRANSFER_PATIENT_REQUEST";
export const FETCH_TRANSFER_PATIENT_SUCCESS= "FETCH_TRANSFER_PATIENT_SUCCESS";
export const FETCH_TRANSFER_PATIENT_FAILURE= "FETCH_TRANSFER_PATIENT_FAILURE";

// Add transfer patient
export const ADD_TRANSFER_PATIENT_REQUEST = "ADD_TRANSFER_PATIENT_REQUEST";
export const ADD_TRANSFER_PATIENT_SUCCESS = "ADD_TRANSFER_PATIENT_SUCCESS";
export const ADD_TRANSFER_PATIENT_FAILURE = "ADD_TRANSFER_PATIENT_FAILURE";

// Edit transfer patient
export const UPDATE_TRANSFER_PATIENT_REQUEST= "UPDATE_TRANSFER_PATIENT_REQUEST";
export const UPDATE_TRANSFER_PATIENT_SUCCESS= "UPDATE_TRANSFER_PATIENT_SUCCESS";
export const UPDATE_TRANSFER_PATIENT_FAILURE= "UPDATE_TRANSFER_PATIENT_FAILURE";

// Delete transfer patient
export const DELETE_TRANSFER_PATIENT_REQUEST= "DELETE_TRANSFER_PATIENT_REQUEST";
export const DELETE_TRANSFER_PATIENT_SUCCESS= "DELETE_TRANSFER_PATIENT_SUCCESS";
export const DELETE_TRANSFER_PATIENT_FAILURE= "DELETE_TRANSFER_PATIENT_FAILURE";

// Reset current transfer patient
export const RESET_CURRENT_TRANSFER_PATIENT= "RESET_CURRENT_TRANSFER_PATIENT";

export const HISTORY_TRANSFER_PATIENT_REQUEST="HISTORY_TRANSFER_PATIENT_REQUEST";
export const HISTORY_TRANSFER_PATIENT_SUCCESS="HISTORY_TRANSFER_PATIENT_SUCCESS";
export const HISTORY_TRANSFER_PATIENT_FAILURE="HISTORY_TRANSFER_PATIENT_FAILURE";


// View single transfer patient
export const FETCH_STAFF_TRANSFER_PATIENT_REQUEST= "FETCH_STAFF_TRANSFER_PATIENT_REQUEST";
export const FETCH_STAFF_TRANSFER_PATIENT_SUCCESS= "FETCH_STAFF_TRANSFER_PATIENT_SUCCESS";
export const FETCH_STAFF_TRANSFER_PATIENT_FAILURE= "FETCH_STAFF_TRANSFER_PATIENT_FAILURE";